import "@szhsin/react-menu/dist/index.css";
import { observer } from "mobx-react";
import React from "react";
import { withWSErrorContainer } from "../../../error/withWSErrorContainer";
import { useReactMenuProps } from "../../../generic-components/common/useReactMenuProps";
import { useWhoAmI } from "../../../user/useWhoAmI";
import { useDevice } from "../../../utils/style/useDevice";
import { completeMenuItem } from "../MenuItems/completeMenuItem";
import { DeepFriedMenuItem } from "../../../generic-components/menu/DeepFriedMenuItem";
import { DepartmentTemplate } from "./DepartmentTemplate";
import {
  StyledProfileBtn,
  StyledProfileDropdown,
  StyledReactControlledMenu,
  StyledSimpleProfileDropdown,
} from "./SharedStyles";
import { useProfileDepartmentItems } from "./useProfileDepartmentItems";
import { recordProfileMenuUrlDebugTap } from "../../../url/attachCurrentUrlToBody";

export const ProfileMenu = withWSErrorContainer(
  observer(() => {
    const { isTabletOrMobile } = useDevice();
    const { confirmedHasVerifiedProfileInConcern, whoAmI } = useWhoAmI();
    const { btnProps, controlledMenuProps } = useReactMenuProps();
    const { onClick: openMenu, ...restBtnProps } = btnProps;
    const profileActivatorProps = {
      ...restBtnProps,
      onClick: (e: React.MouseEvent<HTMLElement>) => {
        recordProfileMenuUrlDebugTap();
        openMenu?.(e);
      },
    };

    return (
      <>
        <input type="hidden" data-testid="id-candidate" value={whoAmI?.idCandidate ?? ''} />
        <input type="hidden" data-testid="identity-provider-user-id" value={whoAmI?.userIdFromIdentityProvider ?? ''} />
        <input type="hidden" data-testid="identity-provider-email" value={whoAmI?.emailFromIdentityProvider ?? ''} />
        <input type="hidden" data-testid="concern-id" value={whoAmI?.concernId ?? ''} />
        
        
        {isTabletOrMobile && (
          <StyledProfileBtn
            role="button"
            className="cvp-profile-btn"
            icon="pi pi-user"
            data-testid="profile-menu-btn"
            {...profileActivatorProps}
          />
        )}

        {!isTabletOrMobile && !!confirmedHasVerifiedProfileInConcern && (
          <StyledProfileDropdown
            role="button"
            aria-label="Profil"
            aria-haspopup="menu"
            data-testid="profile-menu-btn"
            {...profileActivatorProps}
          >
            <DepartmentTemplate isTopBar />
            <i className="pi pi-user" aria-hidden="true" />
          </StyledProfileDropdown>
        )}

        {!isTabletOrMobile && !confirmedHasVerifiedProfileInConcern && (
          <StyledSimpleProfileDropdown
            role="button"
            aria-label="Profil"
            aria-haspopup="menu"
            data-testid="profile-menu-btn"
            {...profileActivatorProps}
          >
            <i className="pi pi-user" aria-hidden="true" />
          </StyledSimpleProfileDropdown>
        )}

        {/* //React menu */}
        <StyledReactControlledMenu {...controlledMenuProps}>
          <ProfileDepReactMenuItems />
        </StyledReactControlledMenu>
      </>
    );
  })
);

interface ProfileDepReactMenuItemsProps {}

const ProfileDepReactMenuItems = withWSErrorContainer(
  observer((props: ProfileDepReactMenuItemsProps) => {
    const profileItems = useProfileDepartmentItems();
    const pItems = profileItems.map((items) => completeMenuItem(items));

    return (
      <>
        {pItems.map((pItem, index) => (
          <DeepFriedMenuItem key={`${index}_${pItem.label}`} pItem={pItem} />
        ))}
      </>
    );
  })
);
